// extracted by mini-css-extract-plugin
module.exports = {"blurb":"Blurb_blurb__B0bLK"};